<template>
  <label :for="item.id">
    <input
      :id="item.id"
      type="radio"
      :value="item.value"
      :checked="isChecked"
      :name="item.id || 'custom-radio-group'"
      @click="handleChange"
    />
    <span>
      {{ item.label }}
    </span>
    <i v-if="item.icon" class="section__option--icon" :class="[item.icon, { rotateDown: isChecked }]"></i>
  </label>
</template>

<script>
export default {
  props: ["item", "isChecked"],
  methods: {
    handleChange(event) {
      this.$emit("passItem", this.item, event);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";

label {
  display: flex;
  align-items: center;
  cursor: pointer;

  i {
    margin-left: auto;
    font-size: 1.3rem;
    transition: transform 0.3s ease;
    transform: rotate(-90deg);
    margin-left: auto;
    cursor: pointer;

    &.rotateDown {
      transform: rotate(0deg); /* rotated to 0 when active */
    }
  }
}

input[type="radio"] {
  position: relative;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.7px solid @kk-color-primary-blue;
  background-color: @kk-color-white;
  cursor: pointer;
  box-sizing: content-box;
  font-weight: bold;
}

input[type="radio"]::before {
  content: attr(id); /* Use the value attribute as the number */
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0.5px;
  font-size: 10px;
  color: @kk-color-primary-blue;
}

input[type="radio"]:checked {
  background-color: @kk-color-primary-blue;
  color: @kk-color-white;
  border-color: @kk-color-primary-blue;
}

input[type="radio"]:checked::before {
  color: @kk-color-white;
}
</style>
